'use client'
import {Image} from '@/src/shared/ui/image'

import {useOAuth} from '@/src/features/auth/model/use-oauth'
import {observer} from 'mobx-react'
import YaIdIcon from '@/src/shared/assets/media/icon-ya.svg'

import * as LoginUI from '../../../ui/login.styled'
import * as YaUI from './btn.styled'

import {OAuthProvider} from '@/src/config/settings'
import {LoadingIcon} from '@/src/shared/ui/icons/loading'

export const YandexIdBtn = observer(() => {
  const {signIn, disabled, loading} = useOAuth({provider: OAuthProvider.YandexId})

  return (
    <YaUI.LoginButton onClick={signIn} data-disabled={disabled}>
      <YaUI.LoginButtonInner title="Войти с Яндекс ID">
        <LoginUI.Icon as={Image} src={YaIdIcon} width={24} height={24} />
        Войти с Яндекс ID
      </YaUI.LoginButtonInner>
      {loading && (
        <LoginUI.Loading>
          <LoadingIcon />
        </LoginUI.Loading>
      )}
    </YaUI.LoginButton>
  )
})
